import { Component } from '@ecs/Component';

export class Lifetime implements Component {
  readonly type = 'Lifetime';

  constructor(
    public current: number,
    public max: number
  ) {}
}